// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_tab {
  margin-left: auto;
  margin-right: 3.5rem;
}
.login_user {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.login_user:hover{
  cursor: pointer;
}
.content_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}

/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .login_tab {
    margin: 0 auto;
  }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/logintab/logintab.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,2GAA2G;AAC3G;EACE;IACE,cAAc;EAChB;AACF;AACA,kGAAkG;AAClG;AACA","sourcesContent":[".login_tab {\n  margin-left: auto;\n  margin-right: 3.5rem;\n}\n.login_user {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n}\n.login_user:hover{\n  cursor: pointer;\n}\n.content_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 10px;\n}\n\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .login_tab {\n    margin: 0 auto;\n  }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
